import { DoughnutChart } from '@/molecules/chartElements';
import MetricProperty from '@enums/MetricProperty';
import tagColor from '@pkg/utils/colors/tag';
import format from '@pkg/utils/numbers/format';
import { EntityMetric } from '@/lib/enums';
import tagPercentages from './utils/tagPercentages';

const TagDoughnut = ({
  comparison,
  direction,
  metricType = EntityMetric.PERCENTAGE,
  onClick,
  size,
  tag,
  totalHours,
}) => {
  const percentages = tagPercentages(tag, totalHours, comparison);
  const color = tagColor({ color: tag.color, property: 'fill' });
  const hoursDisplayValue = format(
    tag.__aggregateHours,
    MetricProperty[EntityMetric.HOURS].formatOptions
  );
  const changeValue =
    metricType === EntityMetric.PERCENTAGE
      ? percentages?.change
      : percentages?.hours;

  const handleClick = () => {
    onClick?.(tag.categoryId, tag.uuid);
  };

  return (
    <DoughnutChart
      color={color}
      description={tag.description}
      direction={direction}
      label={tag.name}
      size={size}
      onClick={handleClick}
      value={percentages.tag}
      metricDisplayValue={
        metricType !== EntityMetric.PERCENTAGE ? hoursDisplayValue : null
      }
      changeValue={changeValue}
      options={{
        cutout: '80%',
        rotation: 270,
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      }}
    />
  );
};

export default TagDoughnut;
